import React, { useEffect, useState } from 'react';
import { FaHandPaper } from 'react-icons/fa';

// terminated giữ 5s như behavior gốc; kicked dài hơn để học viên kịp
// đọc + bấm "Tiếp tục học trên thiết bị này".
const REDIRECT_SECONDS_BY_VARIANT = { kicked: 15, terminated: 5 };

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.75)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 99999,
};

const cardStyle = {
  backgroundColor: '#fff',
  borderRadius: '12px',
  padding: '40px 32px',
  maxWidth: '420px',
  width: '90%',
  textAlign: 'center',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
};

const iconStyle = {
  fontSize: '48px',
  marginBottom: '16px',
};

const titleStyle = {
  fontSize: '18px',
  fontWeight: 600,
  color: '#dc3545',
  marginBottom: '12px',
};

const messageStyle = {
  fontSize: '14px',
  color: '#555',
  marginBottom: '20px',
  lineHeight: 1.5,
};

const countdownStyle = {
  fontSize: '13px',
  color: '#888',
  marginTop: '12px',
};

const primaryBtnStyle = {
  display: 'block',
  width: '100%',
  padding: '10px 16px',
  marginBottom: '10px',
  border: 'none',
  borderRadius: '8px',
  backgroundColor: '#1a73e8',
  color: '#fff',
  fontSize: '14px',
  fontWeight: 600,
  cursor: 'pointer',
};

const secondaryBtnStyle = {
  display: 'block',
  width: '100%',
  padding: '10px 16px',
  border: '1px solid #ccc',
  borderRadius: '8px',
  backgroundColor: '#fff',
  color: '#555',
  fontSize: '14px',
  cursor: 'pointer',
};

/**
 * Overlay khi phiên học bị gián đoạn. `variant`:
 *   - 'kicked'     — phiên bị thiết bị/tab khác takeover. Có nút giành
 *                    lại + countdown về trang chủ (tab bỏ quên tự rời).
 *   - 'denied'     — connect bị từ chối vì thiết bị/tab khác đang giữ
 *                    quyền học (session-ownership). Có nút giành quyền,
 *                    KHÔNG countdown (socket đã dừng hẳn, tab ngồi im
 *                    chờ học viên quyết — tránh vòng lặp redirect→connect
 *                    →denied).
 *   - 'terminated' — admin kết thúc phiên. Không nút, auto-redirect
 *                    (behavior cũ).
 *
 * Nút "Tiếp tục học trên thiết bị này": set cờ takeover one-shot
 * (sessionStorage — key khớp useElearningSession.TAKEOVER_FLAG_KEY) rồi
 * reload; lần connect kế tiếp mang cờ → server chuyển quyền + kick các
 * phiên khác. KHÔNG cần gọi API — quyết định nằm ở socket handshake.
 */
export default function SessionKickedOverlay({ reason, variant = 'terminated' }) {
  const allowTakeover = variant === 'kicked' || variant === 'denied';
  const withCountdown = variant === 'kicked' || variant === 'terminated';
  const [countdown, setCountdown] = useState(REDIRECT_SECONDS_BY_VARIANT[variant] || 5);

  useEffect(() => {
    if (!withCountdown) return undefined;
    if (countdown <= 0) {
      window.location.href = '/';
      return undefined;
    }
    const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown, withCountdown]);

  const handleTakeover = () => {
    try {
      // Key khớp TAKEOVER_FLAG_KEY trong hooks/useElearningSession.js.
      sessionStorage.setItem('elearning-session-takeover', '1');
    } catch (_) { /* noop */ }
    window.location.reload();
  };

  return (
    <div style={overlayStyle}>
      <div style={cardStyle}>
        <div style={iconStyle}><FaHandPaper color='#dc3545' /></div>
        <div style={titleStyle}>Phiên học bị gián đoạn</div>
        <div style={messageStyle}>
          {reason || 'Phiên học đã được mở ở thiết bị/tab khác.'}
          {allowTakeover && (
            <>
              {' '}Nếu bạn muốn học trên thiết bị này, hãy bấm nút bên dưới.
            </>
          )}
        </div>
        {allowTakeover && (
          <>
            <button type='button' style={primaryBtnStyle} onClick={handleTakeover}>
              Tiếp tục học trên thiết bị này
            </button>
            <button
              type='button'
              style={secondaryBtnStyle}
              onClick={() => { window.location.href = '/'; }}
            >
              Về trang chủ
            </button>
          </>
        )}
        {withCountdown && (
          <div style={countdownStyle}>
            Tự động chuyển hướng sau {countdown} giây...
          </div>
        )}
      </div>
    </div>
  );
}
